import type { Template } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaCaretDown, FaHistory, FaPencilAlt, FaRegTrashAlt } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { usePermission } from '../../hooks/usePermission';
import { TemplateDeleteModal } from './TemplateDeleteModal';
import { TemplateEditModal } from './TemplateEditModal';
import { TemplateVersionHistoryModal } from './TemplateVersionHistoryModal';

interface Props extends ChakraV3.ButtonProps {
  template: Template;
}

export const TemplateActionMenu = (props: Props) => {
  const { template, ...rest } = props;

  const editTemplatePermission = usePermission('update', 'template');
  const deleteTemplatePermission = usePermission('delete', 'template');

  return (
    <ChakraV3.Menu.Root lazyMount>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button variant='plain' size='xs' {...rest}>
          Actions
          <FaCaretDown />
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(TemplateVersionHistoryModal, {
                template,
              })
            }
            value='version-history'
          >
            <FaHistory />
            View version history
          </ChakraV3.MenuItem>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(TemplateEditModal, {
                template,
              })
            }
            value='edit'
            disabled={!editTemplatePermission}
          >
            <FaPencilAlt />
            Edit
          </ChakraV3.MenuItem>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(TemplateDeleteModal, {
                templateId: template.id,
                templateName: template.name,
              })
            }
            color='danger'
            value='delete'
            disabled={!deleteTemplatePermission}
          >
            <FaRegTrashAlt />
            Delete
          </ChakraV3.MenuItem>
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
    </ChakraV3.Menu.Root>
  );
};
